import { useState, useEffect } from 'react';
import '../../../../css/freelancer-services.css';
import { fetchPublicServices, getPlatformServicesByProfession, createProfileService, getProfileServices, updateProfileService, deleteProfileService } from '../../../../services/servicesService';

const BusinessServices = ({ businessId }) => {
    // Hooks always first
    const [profileServices, setProfileServices] = useState([]);
    const [isLoading, setLoading] = useState(true);

    useEffect(() => {
        if (!businessId) return; // early exit inside effect

        const fetchProfileServices = async () => {
            setLoading(true);
            try {
                const services = await fetchPublicServices(businessId);
                setProfileServices(services);
            } catch (err) {
                console.error('Error fetching services:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchProfileServices();
    }, [businessId]);

    if (isLoading) return null;

    return (
        <div className="info-container">
            <p
                style={{
                    color: "var(--text)",
                    margin: 0,
                    textAlign: profileServices.length === 0 ? "center" : "right",
                }}
            >
                {profileServices.length === 0
                    ? "No Services Listed"
                    : `${profileServices.length} ${profileServices.length === 1 ? "Service" : "Services"}`}
            </p>

            <div className="services-list">
                {profileServices.map((service, index) => (
                    <div key={service.id} className="service-card">
                        <h4>
                            {service.title}
                            {service.is_custom && <span className="custom-tag">Custom</span>}
                        </h4>

                        {/* <div className='service-actions'>
                            <button
                                className="service-card-ellipsis"
                                onClick={() => setDropdownOpen(dropdownOpen === index ? null : index)}
                            >
                                <i className="fa-solid fa-ellipsis-vertical"></i>
                            </button>

                            {dropdownOpen === index && (
                                <div className="service-dropdown">
                                    <button
                                        onClick={() => handleEditClick(service)}
                                        className='service-dropdown-item'
                                    >
                                        <i className="fas fa-pen"></i> Edit
                                    </button>

                                    <button
                                        onClick={() => handleDeleteService(service)}
                                        className="service-dropdown-item"
                                    >
                                        <i className="fas fa-trash job-delete"></i> Delete
                                    </button>
                                </div>
                            )}
                        </div> */}

                        {service.description && <p>{service.description}</p>}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BusinessServices;